export const inviteReason = (data, what = "invite") => {
  if (data.reason === "email_not_configured")
    return `Email sending isn't switched on for this site yet — ${what} link copied to your clipboard instead.`;
  if (data.reason === "sender_not_verified")
    return `Our email sender address hasn't been verified yet, so the ${what} couldn't go out — link copied instead.`;
  return `The ${what} email couldn't be sent (${data.reason || "unknown error"}) — link copied instead.`;
};

export const MAX_INVITES = 20;

/** Split a pasted blob on commas, semicolons, spaces and new lines. */
export const parseEmails = (text) => {
  const found = String(text || "")
    .split(/[\s,;]+/)
    .map((e) => e.trim().replace(/^[<"']+|[>"']+$/g, "").toLowerCase())
    .filter((e) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(e));
  return [...new Set(found)];
};

/** Toast copy for a bulk invite response. */
export const inviteSummary = (data, what = "invite") => {
  const failed = (data.results || []).filter((r) => !r.sent);
  if (data.sent_count === data.total)
    return data.total === 1
      ? `Invite emailed to ${data.results[0].email}`
      : `${data.total} invites emailed`;
  if (data.sent_count === 0) return inviteReason(data, what);
  return `${data.sent_count} of ${data.total} invites sent — ${failed
    .map((r) => r.email)
    .slice(0, 3)
    .join(", ")} failed`;
};
